export default __webpack_public_path__ + "static/media/employeeBlue.e40dea80.png";